import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FleetSafetyReportComponent } from '@app-reports/pages/fleet-safety-report/fleet-safety-report.component';
import { ReportsComponent } from '@app-reports/pages/reports/reports.component';
import { CoachingSessionReportComponent } from './pages/coaching-session-report/coaching-session-report.component';
import { ExportHistoryComponent } from './components/export-history/export-history.component';
import { CoachingEffectivenessDriverComponent } from './pages/coaching-effectiveness-driver/coaching-effectiveness-driver.component';
import { CreateScheduleComponent } from './components/create-schedule/create-schedule.component';
import { CanDeactivateGuard } from '@app-core/guards/can-deactivate/can-deactivate.guard';
import { FeatureFlagGuard } from '@app-core/guards/feature-flag-guard/feature-flag.guard';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: ReportsComponent,
      },
      {
        path: 'fleet-safety',
        component: FleetSafetyReportComponent,
      },
      {
        path: 'coaching-session',
        component: CoachingSessionReportComponent,
        canActivate: [FeatureFlagGuard],
        data: { featureFlags: 'reports:coaching_session_report' },
      },
      {
        path: 'export-history',
        component: ExportHistoryComponent,
      },
      {
        path: 'coaching-effectiveness-driver',
        component: CoachingEffectivenessDriverComponent,
        canActivate: [FeatureFlagGuard],
        data: { featureFlags: 'reports:coaching_effectiveness_report' },
      },
      {
        path: 'create-schedule',
        component: CreateScheduleComponent,
        canActivate: [FeatureFlagGuard],
        data: { featureFlags: 'schedule_reports' },
        canDeactivate: [CanDeactivateGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportsRoutingModule {}
